import type { FaireProductEntity } from "../../entity_types/product";

export const p_vcd7mfr5nd: FaireProductEntity = {
  token: "p_vcd7mfr5nd",
  type: "product",
  name: 'Metallic Mushroom LED Table Light-8"H-Gold',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/8f2b53c9f38b5e1495a5a630acf47b54c9af00db7500c5df961874bb44d844ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7e80ead40f9ce6129f63b1a4801c3ebc54fc0524625ef78a8a4b1b43addff4b.jpeg",
    "https://cdn.faire.com/fastly/7590fd07aeac3669322fc5df5060a4c4dccbfd2ab563724877c6304131045c9c.jpeg",
  ],
  priceDollars: 45,
  description:
    "Enhance the ambience and decor of any space with this delightful Mushroom LED Table Light. Crafted out of metal, the distinctive shape of this mushroom lamp is accentuated by its simple design for a uniquely illuminating addition to tables, bedside tables, counters and more. Comes with a built-in USB-rechargeable battery and a run time of up to 16 hours. Dimmable with 3 light levels. Also available in 2 other metallic colours. Other LED Table Lights also available.",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:08.928Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
